var map = {
	"./home/_Wheels drawing FINAL.xcf": "ada3",
	"./home/base.png": "294c",
	"./home/green wheel.xcf": "0a6d",
	"./home/green-flapper.png": "5591",
	"./home/green-top-fullres.png": "af8d",
	"./home/green-top.png": "3bbf",
	"./home/how-to-play-btn.png": "9418",
	"./home/orange-flapper.png": "17c5",
	"./home/orange-right-fullres.png": "cd5c",
	"./home/orange-right.png": "c80a",
	"./home/subtitle.png": "20a1",
	"./home/title.png": "5f04",
	"./home/yellow-flapper.png": "63d2",
	"./home/yellow-left-fullres.png": "c888",
	"./home/yellow-left.png": "71f5",
	"./how-to-play/HowToPlay.png": "1727",
	"./how-to-play/askAQuestion.png": "a703",
	"./how-to-play/bg.png": "a52f",
	"./how-to-play/drawTheCards.png": "9d78",
	"./how-to-play/spinTheWheels.png": "2147",
	"./subscribe/line.png": "6ce2",
	"./subscribe/logo.png": "f00f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";